import apiAnimals from "../config/api_animals";
import apiFarms from "../config/api_farms";
import apiFinancial from "../config/api_financial";
import apiHighProcess from "../config/api_highprocess";
import apiManagement from "../config/api_management";
import getHeaders from "./getHeaders";
// import axios from "axios";

// const apiHighProcess = axios.create({
//   baseURL: "http://localhost:8089",
// });

// const apiFarms = axios.create({
//   baseURL: "http://localhost:8082",
// });

export function getImportLog(payload) {
  const { groupId, farmId, id, signal } = payload;

  return apiHighProcess.get(
    `/bovexo/${groupId}/farms/${farmId}/import/log/${id}`,
    getHeaders(false, signal),
  );
}

export function getAnimalImportLog(payload) {
  const { groupId, farmId, page, size, signal } = payload;

  return apiHighProcess.get(
    `/bovexo/${groupId}/farms/${farmId}/animals/import/log?
    ${page ? `&page=${page - 1}` : ""}
    ${size ? `&size=${size}` : ""}`,
    getHeaders(false, signal),
  );
}

export function getAnimalWeightImportLog(payload) {
  const { groupId, farmId, page, size, signal } = payload;

  return apiHighProcess.get(
    `/bovexo/${groupId}/farms/${farmId}/animals/weights/import/log?
    ${page ? `&page=${page - 1}` : ""}
    ${size ? `&size=${size}` : ""}`,
    getHeaders(false, signal),
  );
}

export function getSupplementWeightImportLog(payload) {
  const { groupId, farmId, page, size, signal } = payload;

  return apiHighProcess.get(
    `/bovexo/${groupId}/farms/${farmId}/supplements/import/log?
    ${page ? `&page=${page - 1}` : ""}
    ${size ? `&size=${size}` : ""}`,
    getHeaders(false, signal),
  );
}

export function getSupplementWeightImportLogSupplierGroup(payload) {
  const { groupId, farmId, page, size, signal } = payload;

  return apiFarms.get(
    `/bovexo/suppliers/groups/${groupId}/farms/${farmId}/imports?
    ${page ? `&page=${page - 1}` : ""}
    ${size ? `&size=${size}` : ""}`,
    getHeaders(false, signal),
  );
}

export function importAnimalWeightHistory(payload) {
  const { groupId, farmId, file, identificationType, importType } = payload;

  let formData = new FormData();
  formData.append("file", file);

  let url = `/bovexo/${groupId}/farms/${farmId}/animals/weights/import`;

  if (identificationType !== null && identificationType !== "") {
    url = url + `?identificationType=${identificationType}`;
  }

  if (importType !== null && importType !== undefined && importType !== "") {
    url = url + (url.includes("?") ? "&" : "?") + `importType=${importType}`;
  }

  return apiHighProcess.post(url, formData, getHeaders(true));
}

export function importAnimals(payload) {
  const {
    groupId,
    farmId,
    lotId,
    supplierId,
    importType,
    file,
    lotReceiptId,
    lotItemReceiptId,
    statusToUpdateAnimals,
    identificationType,
  } = payload;
  let formData = new FormData();
  formData.append("file", file);

  let params = "";

  if (supplierId != null) {
    params = `?supplierId=${supplierId}`;
  }

  if (lotReceiptId != null) {
    if (params !== "") {
      params = params + "&";
    } else {
      params = "?";
    }

    params =
      params +
      `lotReceiptId=${lotReceiptId}&lotItemReceiptId=${lotItemReceiptId}`;
  }

  switch (importType) {
    case "ImportAnimalsForOneLotAndSupplier":
      return apiHighProcess.post(
        `/bovexo/${groupId}/farms/${farmId}/lots/${lotId}/animals/import${params}`,
        formData,
        getHeaders(true),
      );
    case "ImportAnimalsForDifferentsLotsAndSuppliers":
      return apiHighProcess.post(
        `/bovexo/${groupId}/farms/${farmId}/animals/import${params}`,
        formData,
        getHeaders(true),
      );
    case "ImportIdentifyAnimals":
      return apiHighProcess.post(
        `/bovexo/${groupId}/farms/${farmId}/animals/import/identify`,
        formData,
        getHeaders(true),
      );
    case "ImportUpdateAnimals":
      return apiHighProcess.post(
        `/bovexo/${groupId}/farms/${farmId}/animals/import/update?status=${statusToUpdateAnimals}&identificationType=${identificationType}`,
        formData,
        getHeaders(true),
      );
    default:
      return null;
  }
}

export function importSupplement(payload) {
  const { groupId, farmId, supplierId, file, isInputSupplier } = payload;

  let formData = new FormData();
  formData.append("file", file);

  let url = "";

  if (supplierId != null) {
    url = `?supplierId=${supplierId}`;
  }

  if (isInputSupplier) {
    return apiFarms.post(
      `/bovexo/suppliers/groups/${groupId}/farms/${farmId}/supplements/import${url}`,
      formData,
      getHeaders(true),
    );
  } else {
    return apiFarms.post(
      `/bovexo/${groupId}/farms/${farmId}/supplements/import${url}`,
      formData,
      getHeaders(true),
    );
  }
}

export function deleteImportWeightFileByRequestId(payload) {
  const { groupId, farmId, id, signal } = payload;

  return apiAnimals.post(
    `/bovexo/${groupId}/farms/${farmId}/animals/import/${id}/delete`,
    {},
    getHeaders(false, signal),
  );
}

export function generateTemplateImportFinancialTransaction(payload) {
  const { groupId, farmId, importNewSupplierClient } = payload;

  return apiFinancial.get(
    `/bovexo/${groupId}/farms/${farmId}/financial/transactions/template/download?importNewSupplierClient=${importNewSupplierClient}`,
    getHeaders(false, null, true),
  );
}

export function importFinancialTransaction(payload) {
  const { groupId, farmId, currencyType, importNewSupplierClient, file } =
    payload;

  let formData = new FormData();
  formData.append("file", file);

  return apiFinancial.post(
    `/bovexo/${groupId}/farms/${farmId}/financial/transactions/import?fileName=BOV_EXO_TEMPLATE&currencyType=${currencyType}&importNewSupplierClient=${importNewSupplierClient}`,
    formData,
    getHeaders(true),
  );
}

export function generateTemplateImportPicketSupplementSupplyAndFeedReader(
  payload,
) {
  const { groupId, farmId } = payload;

  return apiFarms.get(
    `/bovexo/${groupId}/farms/${farmId}/pickets/supplements/supply/download/template`,
    getHeaders(false, null, true),
  );
}

export function importPicketSupplementSupplyAndFeedReader(payload) {
  const { groupId, farmId, file } = payload;

  let formData = new FormData();
  formData.append("file", file);

  return apiFarms.post(
    `/bovexo/${groupId}/farms/${farmId}/pickets/supplements/supply/import`,
    formData,
    getHeaders(true),
  );
}

export function getPicketSupplementSupplyAndFeedReaderImportLog(payload) {
  const { groupId, farmId, page, size, signal } = payload;

  return apiHighProcess.get(
    `/bovexo/${groupId}/farms/${farmId}/pickets/supply/feed-reader/import/log?
    ${page ? `&page=${page - 1}` : ""}
    ${size ? `&size=${size}` : ""}`,
    getHeaders(false, signal),
  );
}

export function getPicketSupplementSupplyAndFeedReaderImportDetails(payload) {
  const { groupId, farmId, id, signal } = payload;

  return apiHighProcess.get(
    `/bovexo/${groupId}/farms/${farmId}/import/log/${id}`,
    getHeaders(false, signal),
  );
}

export function getFinancialTransactionsImportLog(payload) {
  const { groupId, farmId, page, size, signal } = payload;

  return apiHighProcess.get(
    `/bovexo/${groupId}/farms/${farmId}/financial/transactions/import/log?
    ${page ? `&page=${page - 1}` : ""}
    ${size ? `&size=${size}` : ""}`,
    getHeaders(false, signal),
  );
}

export function getAnimalCoveragesImportLog(payload) {
  const { groupId, farmId, page, size, signal } = payload;

  return apiHighProcess.get(
    `/bovexo/${groupId}/farms/${farmId}/animals/coverages/import/log?
    ${page ? `&page=${page - 1}` : ""}
    ${size ? `&size=${size}` : ""}`,
    getHeaders(false, signal),
  );
}

export function generateTemplateImportAnimalCoverage(payload) {
  const { groupId, farmId } = payload;

  return apiAnimals.get(
    `/bovexo/${groupId}/farms/${farmId}/animals/coverages/import/template/download`,
    getHeaders(false, null, true),
  );
}

export function importAnimalCoverage(payload) {
  const { groupId, farmId, file } = payload;

  let formData = new FormData();
  formData.append("file", file);

  return apiAnimals.post(
    `/bovexo/${groupId}/farms/${farmId}/animals/coverages/import`,
    formData,
    getHeaders(true),
  );
}

export function importSuppliersAndClients(payload) {
  const { groupId, farmId, importScope, file } = payload;

  let formData = new FormData();
  formData.append("file", file);

  return apiManagement.post(
    `/bovexo/${groupId}/farms/${farmId}/suppliers/clients/import?scopeImport=${importScope}`,
    formData,
    getHeaders(true),
  );
}

export function getSuppliersClientsImportLog(payload) {
  const { groupId, farmId, page, size, signal } = payload;

  return apiHighProcess.get(
    `/bovexo/${groupId}/farms/${farmId}/suppliers/clients/import/log?
    ${page ? `&page=${page - 1}` : ""}
    ${size ? `&size=${size}` : ""}`,
    getHeaders(false, signal),
  );
}

export function getSuppliersClientsImportDetails(payload) {
  const { groupId, farmId, id, signal } = payload;

  return apiHighProcess.get(
    `/bovexo/${groupId}/farms/${farmId}/import/log/${id}`,
    getHeaders(false, signal),
  );
}

export function importAnimalBirth(payload) {
  const { groupId, farmId, file } = payload;
  let formData = new FormData();
  formData.append("file", file);
  return apiAnimals.post(
    `/bovexo/${groupId}/farms/${farmId}/animals/births/import`,
    formData,
    getHeaders(true),
  );
}

export function getAnimalBirthsImportLog(payload) {
  const { groupId, farmId, page, size, signal } = payload;

  return apiHighProcess.get(
    `/bovexo/${groupId}/farms/${farmId}/animals/births/import/log?
    ${page ? `&page=${page - 1}` : ""}
    ${size ? `&size=${size}` : ""}`,
    getHeaders(false, signal),
  );
}

export function importAnimalVaccination(payload) {
  const { groupId, farmId, file, identificationType } = payload;

  let formData = new FormData();
  formData.append("file", file);

  let url = `/bovexo/${groupId}/farms/${farmId}/animals/vaccinations/import`;

  if (identificationType !== null && identificationType !== "") {
    url = url + `?identificationType=${identificationType}`;
  }

  return apiAnimals.post(url, formData, getHeaders(true));
}

export function getAnimalVaccinationsImportLog(payload) {
  const { groupId, farmId, page, size, signal } = payload;

  return apiHighProcess.get(
    `/bovexo/${groupId}/farms/${farmId}/animals/vaccinations/import/log?
    ${page ? `&page=${page - 1}` : ""}
    ${size ? `&size=${size}` : ""}`,
    getHeaders(false, signal),
  );
}
